<template>
  <Layout
    :title="title"
    :items="items"
  >
    <b-card v-if="isLoading && !title">
      <Skeleton height="60px" />
      <div class="d-lg-flex justify-content-between mt-4 mx-0 gap-4">
        <Skeleton height="25px" />
        <Skeleton height="25px" />
        <Skeleton height="25px" />
      </div>
    </b-card>
    <b-card v-else>
      <template #header>
        <h4 class="card-title">
          {{ deviceDetail.device_id }}
        </h4>
      </template>
      <div class="d-lg-flex justify-content-between mx-0">
        <!-- Type -->
        <div class="d-flex border border-4 border-top-0 border-end-0 border-bottom-0 border-info shadow-sm mb-2">
          <div class="fw-bold ps-3 py-1 bg-white">
            Type
          </div>
          <div class="fw-bold px-2 py-1 bg-white text-capitalize">
            {{ deviceDetail.type.replace(/_/g, ' ') }}
          </div>
        </div>
        <!-- EUI -->
        <div class="d-flex border border-4 border-top-0 border-end-0 border-bottom-0 border-info shadow-sm mb-2">
          <div class="fw-bold ps-3 py-1 bg-white">
            EUI
          </div>
          <div class="fw-bold px-2 py-1 bg-white">
            {{ deviceDetail.device_eui }}
          </div>
        </div>
        <!-- Last uplink -->
        <div
          id="device-last-uplink"
          class="d-flex border border-4 border-top-0 border-end-0 border-bottom-0 border-info shadow-sm mb-2"
        >
          <div class="fw-bold ps-3 py-1 bg-white">
            Last Uplink
          </div>
          <div class="fw-bold px-2 py-1 bg-white">
            {{ deviceDetail.last_uplink_at ? format(new Date(deviceDetail.last_uplink_at), 'dd MMM yyyy HH:mm') : '-' }}
          </div>
        </div>
        <b-tooltip
          target="device-last-uplink"
          triggers="hover"
        >
          <div class="d-flex align-items-center fw-bold">
            <div
              class="me-2"
              :class="{
                'bg-success': deviceDetail.is_connected,
                'bg-danger': !deviceDetail.is_connected,
              }"
              style="width: 10px; height: 10px; border-radius: 50%"
            />
            <div>
              <timeago
                :datetime="deviceDetail.last_uplink_at"
                :auto-update="60"
              />
            </div>
          </div>
        </b-tooltip>
      </div>
    </b-card>
    <DevicePayload
      :device-detail="deviceDetail"
    />
  </Layout>
</template>

<script>
import { format } from 'date-fns';
import Skeleton from '@/components/Skeleton';
import appConfig from '@/app.config';
// import Echo from '@/services/web-socket';
import Layout from '@/layouts/main';
import { formatNumber } from '@/utils/helper';
import DevicePayload from './DevicePayload';

export default {
  page: {
    title: 'Device Detail',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    Skeleton,
    DevicePayload,
  },

  data() {
    return {
      isLoading: false,
      unitDetail: {},
      deviceDetail: {},
      timewindow: {},
      updateCounter: 0,
    };
  },
  computed: {
    buildingId() {
      return this.$route.params.buildingId;
    },
    unitId() {
      return this.$route.params.unitId;
    },
    selectedOrganizationDetail() {
      return this.$store.state.organization.selectedOrganizationDetail;
    },
    title() {
      return this.deviceDetail?.device_id ?? '';
    },
    items() {
      return [
        {
          text: 'HOME',
          to: '/home',
        },
        {
          text: this.selectedOrganizationDetail?.name ?? '',
          to: '/dashboard',
        },
        {
          text: this.unitDetail?.name ?? '',
          to: `/unit/${this.unitId}`,
        },
        {
          text: this.deviceDetail.blocks ? this.deviceDetail.blocks[0].name : '',
          to: `/unit/${this.unitId}/building/${this.buildingId}`,
        },
        {
          text: this.deviceDetail?.device_id ?? '',
          active: true,
        },
      ];
    },
  },
  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler() {
        this.getDeviceDetail(this.$route.params.deviceId);
      },
    },
  },
  beforeDestroy() {
    // leave channel when leaving page
    // this.unsubscribePayload();
  },
  methods: {
    formatNumber,
    format,

    async getUnitDetail() {
      try {
        const { data } = await this.$api.getUnitDetail(this.unitId);
        this.unitDetail = data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getDeviceDetail(deviceId) {
      try {
        this.isLoading = true;
        await this.getUnitDetail();
        const { data } = await this.$api.getDeviceDetail(deviceId);
        this.deviceDetail = data.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    // subscribePayload() {
    //   const buildingDevices = this.buildingDetail?.devices;
    //   buildingDevices.forEach((item) => this.subscribeDevice(item.device_id));
    // },
    // unsubscribePayload() {
    //   const buildingDevices = this.buildingDetail?.devices;
    //   buildingDevices.forEach((item) => (
    //     Echo.leaveChannel(`device.${item.device_id}`)
    //   ));
    // },
    // subscribeDevice(device_id) {
    //   Echo.subscribeChannel(`device.${device_id}`)
    //   // listen new payloads
    //     .listen('EnergyCalculated', (data) => {
    //       this.updateCounter += 1;
    //     });
    // },
  },
};
</script>
